import { Link } from "react-router-dom";

const aboutBg =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20warm%20open%20doorway%20leading%20to%20a%20starry%20night%20landscape%2C%20warm%20amber%20and%20cream%20tones%2C%20inviting%20and%20sophisticated%20magazine%20art%2C%20no%20text&width=1200&height=700&seq=about-banner-001&orientation=landscape";

export default function AboutSection() {
  return (
    <section id="about" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
        <div className="relative overflow-hidden rounded-2xl">
          <img src={aboutBg} alt="幻夜志品牌插画" className="h-full w-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <div className="absolute bottom-5 left-5 rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-medium text-foreground-800 backdrop-blur-sm">
            只收录值得一玩的作品
          </div>
        </div>

        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">About</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            为什么是「幻夜志」
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            成人游戏市场作品繁多、鱼龙混杂，踩雷成本高。幻夜志的初衷很简单——
            由一群真正热爱叙事游戏的编辑，把值得一玩的作品筛选出来，讲清楚它好在哪里、适合谁，
            让每个人都能带着底气做出选择。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们坚持实机体验后再动笔，评分公开透明，也欢迎社区纠错与投稿。
            在这里，没有恰饭吹捧，只有对作品与玩家的尊重。
          </p>

          <div className="mt-6 grid grid-cols-3 gap-3">
            {[
              { icon: "ri-git-merge-line", t: "实机评测", d: "每一篇都亲测" },
              { icon: "ri-shield-check-line", t: "口碑导向", d: "数据公开透明" },
              { icon: "ri-group-line", t: "社区共建", d: "欢迎投稿纠错" },
            ].map((v) => (
              <div key={v.t} className="rounded-xl border border-background-200/70 bg-background-100 p-4">
                <i className={`${v.icon} text-xl text-primary-600`}></i>
                <div className="mt-2 font-display text-sm font-bold text-foreground-950">{v.t}</div>
                <div className="mt-0.5 text-xs text-foreground-500">{v.d}</div>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-accent-700 hover:text-accent-600"
          >
            了解更多关于我们 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}